import Req from '../../req'
const actions = {
    points: function (store, [pid,cb]) {
        let data = {
            pid: pid,
            count: 7 // 天数
        }
        Req.speedShare.points(data, cb);
    },
    deviceInfo: function (store, [pid,cb]) {
        let data = {
            pid: pid,
        }
        Req.speedShare.deviceInfo(data, cb);
    },
}
export default {
    namespaced: false,
    actions
}